
import React, { BaseSyntheticEvent, useState, useEffect, useRef } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import '../apply-rule-modal.css';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { CommonRuleModal } from '../common-rule-modal';
import { IInvokeRuleModalState, ICriteria, IInvokeActionsRuleModalProps, ICoreRule, IExtendedRule } from '../../ILayoutConfigurationPanel.Interface';
import { CQAPIService } from '../../../../../services/http-api.service';
import { Utility } from '../../../../../common/utility';

const INITIAL_STATE = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    selectedFieldType: '',
    referenceField: '',
    referenceTo: '',
    relationshipName:''
}

const cqService = new CQAPIService();
const cqUtility = new Utility();
const layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
const generateSetValueInitialState = () => {
    const selectedField = { ...CQMasterDataStore.Details.selectedFieldDetailsObject }
    return {
        ...cqUtility.createObjectDeepCopy(INITIAL_STATE),
        field: selectedField.fullName,
        selectedFieldType: selectedField.type,
        referenceTo: selectedField.referenceTo || '',
        relationshipName: selectedField.relationshipName || ''
    }
}

const InvokeActionsRulesModalComponent = (props: IInvokeActionsRuleModalProps) => {
        const [state, setState] = useState<ICoreRule>(() => ({
            addedCriterias: [generateSetValueInitialState()],
            actions: [
                { name: '', ns: '' }
            ],
            autoLaunchFlowList: [],
            complexLogicQuery: '1',
            complexLogicVisibility: false,
            shouldSkip: false
        }));

    const [extraState, setExtraState] = useState<IExtendedRule>(() => ({
        additionalFields: [],
        fieldWisePicklistValues: [],
        selectedReferenceFields: [],
    }));

    const [shouldValidate, setShouldValidate] = useState(false);

    useEffect(() => {
        async function initializeStates() {
            const autoLaunchFlowList = await cqService.getAutoLaunchFlows();
            if(!props.appliedRule) {
                const stateCopy = cqUtility.createObjectDeepCopy(state);
                stateCopy.autoLaunchFlowList = autoLaunchFlowList;
                setState(stateCopy);
                return;
            }

            const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
            const objName = props.objectName;
            const ruleElement = { ...(ruleObject[objName!])[props.appliedRule] };

            if(!ruleElement) {
                return;
            }

            const selectedObjectName = CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName, 'selectedObject');
            
            let selectedReferenceFields: any[] | undefined = [];
            let fieldWisePicklistValues = ruleElement.fieldWisePicklistValues;
            if (ruleElement.selectedReferenceFields) {
                selectedReferenceFields = await layoutFieldsConfigCtrl.getLookFieldsDataInEditMode(ruleElement.selectedReferenceFields);
                selectedReferenceFields = (selectedReferenceFields && selectedReferenceFields.length > 0) ? selectedReferenceFields : [];
            }


            if(ruleElement.fieldWisePicklistValues){
                fieldWisePicklistValues = await layoutFieldsConfigCtrl.getPickListValueDataInEditMode(selectedObjectName,ruleElement.fieldWisePicklistValues);
                fieldWisePicklistValues = (fieldWisePicklistValues && fieldWisePicklistValues.length > 0) ? fieldWisePicklistValues : [];
            }
            props.setRuleObject(ruleElement);
            setState({
                actions:ruleElement.actions,
                autoLaunchFlowList: autoLaunchFlowList,
                addedCriterias: ruleElement.addedCriterias,
                complexLogicQuery: ruleElement.hasOwnProperty('complexLogicQuery') ? ruleElement.complexLogicQuery : '',
                complexLogicVisibility: ruleElement.complexLogicVisibility,
                shouldSkip: ruleElement.shouldSkip
            });

            setExtraState({
                selectedReferenceFields,
                fieldWisePicklistValues,
                additionalFields: ruleElement.additionalFields
            });    
        }
        initializeStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());
        props.checkValidation(validateAddRuleForm());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraState]);

    function generateMergedStore(): IInvokeRuleModalState {
        return {...state, ...extraState};
    }

    /**
     * @description updates rule object and checks for validation for rule
     * @memberof ToggleActionsRulesModalComponent
     */
     function updateRuleObject(ruleObjectProperty: string, ruleObjectValue: any) {
        props.setRuleObject(ruleObjectValue);
        props.checkValidation(validateAddRuleForm());
    }

    /**
     * @description Used for validation for rule added for field type
     * @returns { boolean } if state are valid then returns false else true
     * @memberof ToggleActionsRulesModalComponent
     */
     function validateAddRuleForm() {
        if (!shouldValidate) {
            return true;
        } 
        const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        if (!fieldObj.isComponentEventRule) {
            // let isComplexLogicValid = false;
            let isCriteriaValid = state.addedCriterias.every((criteria: ICriteria, index: number) => (criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))
                && (((CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType)) ?
                    ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY || index === 0) ? true :
                        (criteria.referenceField !== '')) : true)));
            if(state.shouldSkip){
                isCriteriaValid = true;
            }
            const isActionValid = state.actions.every((action: any) => (action.name !== ''));
            if (!isCriteriaValid || state.complexLogicQuery === '' || !isActionValid) {
                return true;
            }
            return false;
        }
        else {
            const isActionValid = state.actions.every((action: any) => (action.name !== ''));
            return !isActionValid;
        }

    }

    /**
     * @description sets the validation boolean to true if false
     */
    const setValidation = () => {
        if(!shouldValidate){
            setShouldValidate(true);
        }
    }

    /**
     * @private
     * @memberof InvokeActionsRulesModalComponent
     */
    const onFlowChanged = (e: BaseSyntheticEvent, actionIndex: number) => {
        setValidation();
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        const actions = stateCopy.actions;
        const selectedFlow = stateCopy.autoLaunchFlowList.filter((flowDetails: any) => {
            return flowDetails.Definition.DeveloperName === e.target.value;
        });

        actions[actionIndex].name = selectedFlow[0].Definition.DeveloperName;
        if (selectedFlow[0].Definition.NamespacePrefix) {
            actions[actionIndex].ns = selectedFlow[0].Definition.NamespacePrefix;
        }
        setState(stateCopy);
        updateRuleObject(CQAppConstant.ACTION, stateCopy);

    }

    /**
     * @private
     * @memberof InvokeActionsRulesModalComponent
     */
    const addAction = () => {
        setValidation();
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        const action: any = { 
            name: '', 
            ns: '' 
        }
        stateCopy.actions.push(action);
        setState(stateCopy);
        updateRuleObject(CQAppConstant.ACTION, stateCopy);
    }

    /**
     * @private
     * @memberof InvokeActionsRulesModalComponent
     */
    const deleteAction = (actionIndex: number) => {
        setValidation();
        const stateCopy = cqUtility.createObjectDeepCopy(state);
        let actions = stateCopy.actions;
        actions = actions.filter((action: any, index: number) => index !== actionIndex);
        stateCopy.actions = actions;
        setState( stateCopy )
        updateRuleObject(CQAppConstant.SET_VALUES, stateCopy);
    }

    /**
     * @description Used to set validation true for new states
     * @param newState contains state copy
     */
    function updateState (newState: ICoreRule) {
        setValidation();
        setState(newState);
    }

    return (
        <>
            <div className="slds-grid slds-grid_vertical">
                <CommonRuleModal
                    modalInfo= {{
                        shouldRenderAddComplexBtn: true,
                        shouldDisableFirstElement: true,
                        toggleModalVisibility: props.toggleModalVisibility
                    }}
                    parentAction= {{
                        updateState: (state: ICoreRule) => updateState(state),
                        updateExtraState: (state: IExtendedRule) => setExtraState(state)
                    }}
                    parentInfo= {{
                        state,
                        extraState,
                        initialCriteria: INITIAL_STATE,
                        addFieldOnSkip: true
                    }}
                    objectName= {props.objectName}
                    templateName= {props.selectedTemplateName}
                />

                <h3 className="slds-m-bottom_small">Flow</h3>
                {
                    state.actions.map((action: any, actionIndex: number) => {
                        return (
                            <div key={actionIndex} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                <div className="slds-col col-sm slds-m-bottom_small">{actionIndex + 1}</div>
                                <div className="slds-col slds-size_8-of-12">
                                    <div className="slds-form-element">
                                        <div className="slds-form-element__control">
                                            <div className="slds-select_container">
                                                <select role="select-flow" className="slds-select" id="select-01"
                                                    onChange={e => onFlowChanged(e, actionIndex)} 
                                                    value={action.name}>
                                                    <option value="">Select flow</option>
                                                    {
                                                        state.autoLaunchFlowList.map((flowData: any, index: number) => <option key={index}
                                                                value={flowData.Definition.DeveloperName}>{`${flowData.MasterLabel}`}
                                                            </option>)
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="slds-col slds-size_2-of-12">
                                    <div className="slds-grid slds-m-bottom_xx-small">
                                        <button role="add-action" className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                            addAction();
                                        }}>
                                            <i className="cq-icon-add"></i>
                                        </button>
                                        {actionIndex !== 0 &&
                                            <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                deleteAction(actionIndex);
                                            }}>
                                                <i className="cq-icon-delete"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </>
    );
}
export const InvokeActionsRulesModal = observer(InvokeActionsRulesModalComponent);
